import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getApi } from "../../api/api";
import {
  setPaymentMethods,
  selectPaymentMethods,
} from "../../store/slices/paymentMethodsSlice";

export const usePaymentMethodsContent = () => {
  const dispatch = useDispatch();
  const api = getApi();

  const methods = useSelector(selectPaymentMethods);

  const deleteMethod = useCallback(
    async (id: number) => {
      try {
        await api.deletePaymentMethod(id);
        const response = await api.getPaymentMethods();
        dispatch(setPaymentMethods(response.data || []));
      } catch (err) {
        console.error("Ошибка удаления карты:", err);
      }
    },
    [api, dispatch],
  );

  const setDefaultMethod = useCallback(
    async (id: number) => {
      try {
        await api.setDefaultPaymentMethod(id);
        const response = await api.getPaymentMethods();
        dispatch(setPaymentMethods(response.data || []));
      } catch (err) {
        console.error("Ошибка установки основной карты:", err);
      }
    },
    [api, dispatch],
  );

  return {
    methods,
    deleteMethod,
    setDefaultMethod,
  };
};
